<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'REQUISITOS.LBL_INFOGENERAL' | translate}}">
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'REQUISITOS.LBL_CODIGOIDENTIFICACION' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{requisito.codigo}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'REQUISITOS.LBL_NOMBRE' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{requisito.nombre}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'REQUISITOS.LBL_CODEUDORES' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{requisito.numeroDeudores}}</strong></label>

          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'REQUISITOS.LBL_MONTOMAXIMOHASTA' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{requisito.montoMaximo}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'REQUISITOS.LBL_GARANTIAS' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{requisito.garantia}}%</strong></label>

          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'REQUISITOS.LBL_UNIDADCREDITO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{requisito.indicadorUnidadCredito ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'REQUISITOS.LBL_REQUIEREGARANTIA' | translate }}:</label>
          <label
            class="lg:col-3 col-6 md:col-8"><strong>{{requisito.indicadorRequiereFondoGarantiaIdonea ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_HABILITADO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{requisito.indicadorHabilitado ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>

        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <h3 class="titulo-pagina">{{ 'REQUISITOS.LBL_MODALIDAD' | translate}}</h3>
          </div>
        </div>
        <div class="grid">
          <div class="col-12">
            <p-table [columns]="colModalidad"
                     [value]="lisRequisitoModalidad"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{row.modalidad}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>

        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <h3 class="titulo-pagina">{{ 'REQUISITOS.LBL_TIPORESPARDO' | translate}}</h3>
          </div>
        </div>
        <div class="grid">
          <div class="col-12">
            <p-table [columns]="colTipoRespaldo"
                     [value]="lisRequisitoTipoRespaldo"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{row.tipoRespaldo}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>

      </p-panel>
    </div>
  </div>

  <!-- DATA TABLE PRODUCTOS -->
  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'REQUISITOS.LBL_PRODUCTOS' | translate}}">
        <p-table [columns]="colProductos"
                 [value]="lisProductos"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.nombreProducto}}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-panel>
    </div>
  </div>

  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'REQUISITOS.LBL_RESPALDO' | translate}}">
        <p-table [columns]="columnas"
                 [value]="respaldos"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.nombreRespaldo}}</td>
              <td > {{row.tiposVinculaciones}} <span *ngIf="row.verMasTiposVinculaciones" (click)="detalleTabla(row, 'tipoVincularion')" style="cursor: pointer;">...</span></td>
              <td >{{row.productos}} <span *ngIf="row.verMasProductos" (click)="detalleTabla(row, 'producto')" style="cursor: pointer;">...</span></td>
              <td >{{row.actividades}} <span *ngIf="row.verMasActividades" (click)="detalleTabla(row, 'actividad')" style="cursor: pointer;">...</span></td>

            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-panel>
    </div>
  </div>
  <div class="grid" *ngIf="requisito?.indicadorUnidadCredito">
    <div class="col-12">
      <p-panel header="{{ 'REQUISITOS.LBL_UNIDADCREDITO' | translate}}">
        <p-table [columns]="colTipoVinculacion"
                 [value]="lisRespCantidad"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.tiposVinculaciones}}</td>
              <td class="text-center">
                {{row.cantidad}}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-panel>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
              pButton (click)="regresar()"></button>
    </div>
  </div>
</div>

<p-dialog id="dlgCausales"
          [draggable]="false"
          [resizable]="false"
          [closable]="true"

          *ngIf="detalle"
          [(visible)]="detalle"
          [contentStyle]="{'width':'600px', 'overflow-y': 'auto', 'max-height': '350px', 'overflow-x': 'auto'}"
          [header]="tituloDetalle"
          [modal]="true">

  <div class="grid form-group">
    <div class="col-12 md:col-12 lg:col-12">
      <div class="div-form">
        {{textoDetalle}}
      </div>
    </div>
  </div>
</p-dialog>
